angular.module('elfium').controller('contactDetailModalController', ['$scope', '$uibModalInstance', '$timeout', '$q', 'contactService', 'companyService', 'elfiumRelatedOptionsService', 'elfiumModalFactory', 'elfiumToastrService', 'elfiumLoginService', 'elfiumMissingRequiredFieldsFilter', 'contactId', 'ELFIUM_SELECT_OPTIONS', 'CONTACT_REQUIRED_FIELDS',
    function ($scope, $uibModalInstance, $timeout, $q, contactService, companyService, elfiumRelatedOptionsService, elfiumModalFactory, elfiumToastrService, elfiumLoginService, elfiumMissingRequiredFieldsFilter, contactId, ELFIUM_SELECT_OPTIONS, CONTACT_REQUIRED_FIELDS) {
        var that = this;
        that.elfiumModal = null;
        $scope.selectOptions = ELFIUM_SELECT_OPTIONS;
        that.buildCompanyOptionsAndContact = function () {
            elfiumRelatedOptionsService.getCompanyOptions().then(function (companyOptions) {
                $scope.companyOptions = companyOptions;
                that.getRelatedOptions();
                that.getContact().then(that.assignContactAndRegisterWatch, elfiumToastrService.error);
            }, elfiumToastrService.error);
        };
        that.assignContactAndRegisterWatch = function (contact) {
            $scope.contact = contact;
            that.elfiumModal = new elfiumModalFactory($scope, $uibModalInstance, contact);
            that.registerChangeCompanyWatch();
        };
        that.getRelatedOptions = function () {
            elfiumRelatedOptionsService.getUserOptions().then(function (userOptions) {
                $scope.userOptions = userOptions;
            }, elfiumToastrService.error);
        };   
        that.getContact = function () {
            var contact = null;
            if (contactId) {
                contact = that.loadContact(contactId);
            } else {
                contact = that.buildContact();
            }
            return $q.when(contact);
        };
        that.loadContact = function (contactId) {
            return contactService.getContact(contactId);
        };
        that.buildContact = function () {
            return {
                aktivni: true,
                userId: elfiumLoginService.getUserId(),
                status: $scope.selectOptions.status[0]
            };
        };
        that.prefillAddressFromCompany = function (newCompanyId) {
            companyService.getCompany(newCompanyId).then(function (company) {
                $scope.contact.adresa = $scope.contact.adresa || {};
                $scope.contact.adresa.ulice = company.adresa.ulice;
                $scope.contact.adresa.cisloPopisne = company.adresa.cisloPopisne;
                $scope.contact.adresa.mesto = company.adresa.mesto;
                $scope.contact.adresa.psc = company.adresa.psc;
            }, elfiumToastrService.error);
        };
        that.registerChangeCompanyWatch = function () {
            $scope.$watch('contact.firmaId', function (newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    that.prefillAddressFromCompany(newValue);
                }
            });
        };
        that.upsertContact = function () {
            contactService.upsertContact($scope.contact).then(function () {
                that.elfiumModal.mainObjectSaved();
                elfiumToastrService.success('Osoba byla uložena!');
                $uibModalInstance.close();
            }, elfiumToastrService.error);
        };
        $scope.okClicked = function () {
            $timeout(function () {
                var missingRequiredFields = elfiumMissingRequiredFieldsFilter($scope.contact, CONTACT_REQUIRED_FIELDS);
                if (missingRequiredFields.length) {
                    elfiumToastrService.error('Vyplňte povinné údaje: ' + missingRequiredFields.join(', '));
                } else {
                    that.upsertContact();
                }      
            });
        };
        $scope.delete = function () {
            contactService.openDeleteConfirmationModal().then(function () {
                $timeout(function () {
                    contactService.deleteContact($scope.contact.id).then(function () {
                        elfiumToastrService.success('Osoba byla smazána!');
                        $uibModalInstance.close();
                    }, elfiumToastrService.error);
                });
            });
            
        };
        that.buildCompanyOptionsAndContact();
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/contact/contactDetailModalController.ts